import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";
import moment from 'moment';

export default {
    getOperationEntitiesByGroupForDropDown,
    getCollectionPointsByOperationentityGroupID,
    getGangByCollectionPointID,
    GetDailyHarvesterPerformancesReport
};

async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getCollectionPointsByOperationentityGroupID(operationEntityID, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function getGangByCollectionPointID(operationEntityID, collectionPointID) {
    var gangArray = [];
    const response = await CommonGet('/api/Gang/GetGangBySearch', "operationEntityID=" + parseInt(operationEntityID) + '&collectionPointID=' + parseInt(collectionPointID));
    for (let item of Object.entries(response.data)) {
        gangArray[item[1]["gangID"]] = item[1]["gangName"]
    }
    return gangArray;
}

async function GetDailyHarvesterPerformancesReport(data) {
    var model = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        collectionPointID: parseInt(data.collectionPointID),
        year: parseInt(moment(data.month).format('YYYY')),
        month: parseInt(moment(data.month).format('MM'))
    }
    const response = await CommonPost('/api/DailyPluckingAverageAnalysisRegisteredReport/GetDailyPluckingAverageAnalysisRegisteredReportData', null, model);
    return response.data;
}

